import type { FocusEvent } from 'react';
import { useCallback } from 'react';
import { useStoreActions, useStoreState } from '@/store';

type useHandleFormFocusReturn = (e: FocusEvent<HTMLFormElement>) => void;

export const useHandleFormFocus = (): useHandleFormFocusReturn => {
  const formFocused = useStoreState(({ ui }) => ui.hasFormBeenFocused);
  const setFormFocus = useStoreActions(({ ui }) => ui.setHasFormBeenFocused);

  return useCallback(
    e => {
      // Only cause state update when needed to avoid rerenders
      if (!formFocused) {
        // We only count interaction with input and select as focus
        const tag = e.target?.tagName?.toLocaleLowerCase() || '';

        if (tag === 'input' || tag === 'select') {
          setFormFocus(true);
        }
      }
    },
    [formFocused],
  );
};
